import { lazy, Suspense } from "react";
import Navigation from "@/components/landing/Navigation";
import OptimizedHeroSection from "@/components/landing/OptimizedHeroSection";

// Lazy load below-fold components to reduce main-thread work
const ScienceSummarySection = lazy(() => import("@/components/landing/ScienceSummarySection"));
const StickyFloatingCTA = lazy(() => import("@/components/landing/StickyFloatingCTA"));
const NADDeclineSection = lazy(() => import("@/components/landing/NADDeclineSection"));
const BenefitsSection = lazy(() => import("@/components/landing/BenefitsSection"));
const ScienceSection = lazy(() => import("@/components/landing/ScienceSection"));
const IngredientsSection = lazy(() => import("@/components/landing/IngredientsSection"));
const IngredientComparisonTable = lazy(() => import("@/components/landing/IngredientComparisonTable"));
const ComparisonSection = lazy(() => import("@/components/landing/ComparisonSection"));
const TestimonialsSection = lazy(() => import("@/components/landing/TestimonialsSection"));
const VideoTestimonialsCarousel = lazy(() => import("@/components/landing/VideoTestimonialsCarousel"));
const PricingSection = lazy(() => import("@/components/landing/PricingSection"));
const GuaranteeSection = lazy(() => import("@/components/landing/GuaranteeSection"));
const FAQSection = lazy(() => import("@/components/landing/FAQSection"));
const FinalCTASection = lazy(() => import("@/components/landing/FinalCTASection"));
const FreeEbookSection = lazy(() => import("@/components/landing/FreeEbookSection"));

const Index = () => {

  return (
    <main className="w-full overflow-x-hidden bg-background">
      <Navigation />
      
      {/* Optimized Hero with VSL - Curiosity-driven, no pricing */}
      <OptimizedHeroSection />

      {/* Lazy loaded below-fold content */}
      <Suspense fallback={<div className="min-h-screen" />}>
        {/* Science Summary - Compliant research overview */}
        <ScienceSummarySection />

        {/* Free Ebook Lead Capture - Soft engagement */}
        <FreeEbookSection />

        <NADDeclineSection />
        <section id="benefits">
          <BenefitsSection />
        </section>
        <ScienceSection />

        <IngredientsSection />
        <IngredientComparisonTable />
        <ComparisonSection />
        <section id="reviews">
          <VideoTestimonialsCarousel />
          <TestimonialsSection />
        </section>
        <PricingSection />
        <GuaranteeSection />
        <section id="faq">
          <FAQSection />
        </section>
        <FinalCTASection />
        <StickyFloatingCTA />
      </Suspense>
    </main>
  );
};

export default Index;
